import '../DataCollectionGroupPanel.css'

import React from 'react'
import { Table } from 'react-bootstrap'

export default class FirstSectionPanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  render() {
    return (
      <Table>
        <tbody>
          {this.getRow('Workflow', this.props.datacollectiongroup.workflowType)}
          {this.getRow('Acronym', this.props.datacollectiongroup.acronym)}
          {this.getRow('Sample', this.props.datacollectiongroup.sampleName)}
          {this.getRow('Prefix', this.props.datacollectiongroup.prefix)}
          {this.getRow('Run Number', this.props.datacollectiongroup.runNumber)}
          {this.getRow(
            '# Images (Total)',
            this.props.datacollectiongroup.numberOfImages +
              '(' +
              this.props.datacollectiongroup.totalNumberOfImages +
              ')'
          )}
          {this.getRow('Transmission', this.props.datacollectiongroup.transmission + ' %')}
        </tbody>
      </Table>
    )
  }
}
